import { TadaAyanaAPI } from ".";

export default {
  getUsers() {
    return TadaAyanaAPI.get("/users");
  }
};
